<template>
  <v-tooltip location="bottom"
  >
    <template #activator="{ props }">
      <v-btn
        icon
        :width="width"
        :height="height"
        :elevation="elevation"
        :class="btnClasses"
        v-bind="{ ...$attrs, ...props }"
      >
        <v-icon
          size="small"
          :x-small="small || xsmall"
          color="orange"
        >mdi-alert</v-icon>
      </v-btn>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'BaseWarningIcon',

  props: {
    label: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    xsmall: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: Number,
      default: 0,
    },
    inputClasses: {
      type: String,
      default: '',
    },
  },

  computed: {
    btnClasses: function () {
      let classes = [];
      let inputClasses = this.inputClasses.split(' ');
      if (!this.xsmall && !inputClasses.includes('ma-0')) {
        classes.push('ma-1');
      }
      inputClasses.forEach((item => {
        classes.push(item);
      }))
      return classes;
    },
    width: function () {
      if (this.xsmall) {
        return 12; //20;
      } else if (this.small) {
        return 20; //28;
      }
      return 28; //36;
    },
    height: function () {
      if (this.xsmall) {
        return 12; //20;
      } else if (this.small) {
        return 20; //28;
      }
      return 28; //36;
    },
  },
};
</script>
